if (!customElements.get('ftd-app-accessibility')) {
  customElements.define('ftd-app-accessibility', class extends HTMLElement {
    connectedCallback() {
      const labelPosts = () => {
        this.querySelectorAll('.instafeed-new-layout-item-container[role="link"]').forEach((post, index) => {
          // Preserve names supplied by the app, including any visible caption.
          if (post.hasAttribute('aria-label') || post.hasAttribute('aria-labelledby') || post.textContent.trim()) return;
          const description = post.querySelector('img[alt]')?.getAttribute('alt')?.trim();
          post.setAttribute('aria-label', description || `${this.dataset.instagramLabel} ${index + 1}`);
        });
      };
      labelPosts();
      // Instafeed inserts its items asynchronously and can replace them in the editor.
      this.observer = new MutationObserver(labelPosts);
      this.observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
